import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

export default function() {
  if (
    process.env.NODE_ENV !== 'development' &&
    !!FRONT_SENTRY_DNS &&
    !!DOCKER_IMAGE_TAG &&
    !!SENTRY_ENVIROMENT
  ) {
    Raven.config(FRONT_SENTRY_DNS, {
      release: DOCKER_IMAGE_TAG,
      environment: SENTRY_ENVIROMENT,
    })
      .addPlugin(RavenVue, Vue)
      .install();
  }
}
